import { NextSeo as BaseNextSeo, NextSeoProps as BaseNextSeoProps } from 'next-seo';

import { useCanonicalUrl } from '@pflegia/ui/hooks/use-canonical-url';

interface NextSeoProps extends BaseNextSeoProps {
  defaultDomain: string;
  flavorDomain: string;
}

const NextSeo: React.FC<NextSeoProps> = ({ defaultDomain, flavorDomain, canonical, openGraph, ...props }) => {
  const getCanonicalUrl = useCanonicalUrl();
  const resolvedCanonicalUrl = canonical ?? getCanonicalUrl({ defaultDomain, flavorDomain });
  const resolvedOpenGraph = openGraph
    ? {
        ...openGraph,
        url: openGraph.url ?? resolvedCanonicalUrl,
      }
    : undefined;

  return (
    <BaseNextSeo
      languageAlternates={[{ hrefLang: 'de', href: resolvedCanonicalUrl }]}
      {...props}
      canonical={resolvedCanonicalUrl}
      {...(resolvedOpenGraph ? { openGraph: resolvedOpenGraph } : {})}
    />
  );
};

export default NextSeo;
